import { NavigateFunction } from 'react-router-dom';
export class NavigationManager {
    private navigate : NavigateFunction;

    constructor(navigate: NavigateFunction) {
        this.navigate = navigate;
    }

    to(url: string, shouldReplace?: boolean){
        this.navigate('/' + url, { replace: shouldReplace, relative: "route" });
    }
}

// Test-only helper: navigation is a no-op (useNavigate cannot be called outside a component)
export const createNavigationManagerMock = (): NavigationManager =>
    new NavigationManager((() => undefined) as NavigateFunction);